function initToast() {
  const t = document.createElement("div");
  t.id = "toastEl";
  t.classList.add("toast");
  document.body.appendChild(t);
}
initToast();

export default function toast(msg, duration = 3000, type = "default") {
  let t = document.getElementById("toastEl");
  t.textContent = msg;

  // 移除所有可能的类型类
  t.classList.remove("show", "error", "success", "warning");

  // 强制重绘以触发动画
  void t.offsetWidth;

  // 添加对应的类型类
  if (type === "error") {
    t.classList.add("error");
  } else if (type === "success") {
    t.classList.add("success");
  } else if (type === "warning") {
    t.classList.add("warning");
  }

  t.classList.add("show");
  clearTimeout(window._tt);
  window._tt = setTimeout(() => {
    t.classList.remove("show", "error", "success", "warning");
  }, duration);
}
